import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import styled from "styled-components";
import { io } from "socket.io-client";
import social from "../assets/perks/message.svg";

const music_files = {
  bid: "https://live-nft-hosted-assets.s3.ap-south-1.amazonaws.com/New+Bid+alert.mp3",
  new: "https://live-nft-hosted-assets.s3.ap-south-1.amazonaws.com/NFT+Dropped+alert.mp3",
  win: "https://live-nft-hosted-assets.s3.ap-south-1.amazonaws.com/Auction+Winner+alert.mp3",
};

const Mobile = styled.div`
  display: none;
  @media only screen and (max-device-width: 480px) {
    display: flex;
    height: 100vh;
    flex-direction: column;
  }
  @media only screen and (min-device-width: 480px) 
                   and (max-device-width: 920px) 
                   and (orientation: landscape) {

    display: flex;
    height: 100vh;
    flex-direction: column;
}
`;

const Desktop = styled.div`
  display: none;
  @media (min-device-width: 481px) {
    display: flex;
    flex-direction: column;
    height: 100vh;
    opacity: 0.8
    align-items: flex-end;
    padding-left: 50px;
  }
`;


const Title = styled.div`
  font-family: Chakra Petch;
  font-style: normal;
  font-weight: bold;
  font-size: 30px;
  line-height: 90%;
  /* or 27px */

  display: flex;
  align-items: center;
  text-align: center;

  color: #ffffff;

  /* Brainfuck */

  text-shadow: 0px 4px 20px rgba(255, 255, 255, 0.4),
    0px 4px 4px rgba(0, 0, 0, 0.1);
  overflow-wrap: anywhere;
`;


const Button = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  display: flex;
  align-items: center;

  color: #000;
  background: #fff;
  padding: 12px;
  border-radius: 12px;
  margin: 8px;
`;

const Price = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  display: flex;
  align-items: center;

  color: #ffffff;
`;

const Subtitle = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  /* identical to box height */

  display: flex;
  align-items: center;

  color: #9c9c9c;
  font-family: Chakra Petch;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 145%;
  /* or 17px */

  display: flex;
  align-items: center;
  text-align: center;

  color: #ffffff;

  /* Brainfuck */

  text-shadow: 0px 4px 20px rgba(255, 255, 255, 0.4),
    0px 4px 4px rgba(0, 0, 0, 0.1);
`;


const Box = styled.div`
  clip-path: polygon(100% 0%, 100% 85%, 92% 100%, 0% 100%, 0% 15%, 8% 0%);
  width: 234px;
  background: #000;
  background: linear-gradient(68.93deg, #7748e5 4.36%, #1c77fa 96.41%);
  background: ${(props) =>
    props.winner
      ? "linear-gradient(180deg, #ffd600 0%, #ff7a00 100%)"
      : " linear-gradient(68.93deg, #7748E5 4.36%, #1C77FA 96.41%)"};
  padding: 4px;
  margin-left: 20px;
  margin-top: 12px;
`;

const PurpleBox = styled.div`
  clip-path: polygon(100% 0%, 100% 85%, 92% 100%, 0% 100%, 0% 15%, 8% 0%);
  width: 234px;
  background: #000;
  background: #7c20f9;
  padding: 4px;
  margin-left: 20px;
  margin-top: 12px;
`;

const BoxInner = styled.div`
  width: 100%;
  height: 100%;
  background: ${(props) =>
    props.winner
      ? "rgba(196, 196, 196, 1)"
      : "linear-gradient(180deg, #1024DD 0%, #000855 100%)"};
  clip-path: polygon(100% 0%, 100% 85%, 92% 100%, 0% 100%, 0% 15%, 8% 0%);
  padding: ${(props) => (props.winner ? "0px" : "10px")};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
`;

const PurpleBoxInner = styled.div`
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, #2b1941 0%, #220647 75.86%);
  clip-path: polygon(100% 0%, 100% 85%, 92% 100%, 0% 100%, 0% 15%, 8% 0%);
  padding: ${(props) => (props.winner ? "0px" : "10px")};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
`;

const Text = styled.div`
  font-family: Chakra Petch;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 145%;
  /* or 15px */

  display: flex;
  align-items: center;
  text-align: center;

  color: #ffffff;
`;

const Bidder = styled.div`
  font-family: Chakra Petch;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 145%;
  /* identical to box height, or 15px */

  display: flex;
  align-items: center;
  text-align: center;

  color: #ffffff;

  /* Brainfuck */

  text-shadow: 0px 4px 20px rgba(255, 255, 255, 0.4),
    0px 4px 4px rgba(0, 0, 0, 0.1);
`;

const Message = styled.div`
  font-family: Chakra Petch;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 145%;
  color: #ffffff;
  text-shadow: 0px 4px 20px rgba(255, 255, 255, 0.4),
    0px 4px 4px rgba(0, 0, 0, 0.1);
`;

const TimerTitle = ({ auctionEndingAt }) => {
  const [timer, setTimer] = useState({});

  useEffect(() => {
    setTimeout(async () => {
      let temp_timer = calculateTimeLeft(auctionEndingAt);
      setTimer(temp_timer);
    }, 1000);
  }, [timer]);

  const calculateTimeLeft = (time) => {
    let difference = new Date(time) - new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
        show: true,
      };
    }

    return timeLeft;
  };

  let timeLeft = timer;
  // console.log(timeLeft)

  return (
    <>
      {timeLeft && timeLeft.show && (
        <Text style={{ paddingLeft: 6 }}>
          <span style={{ color: "#fff", marginRight: 6 }}>
            {timeLeft.minutes}m {timeLeft.seconds}s
          </span>
        </Text>
      )}
    </>
  );
};

export default function OverlayTriggerTest(props) {


  const throww = (item) => {
    fetch('https://be.namasteapis.com/api/v1/flash-test', {
        method: 'post',
        headers: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({type: item})
    })
  }


  return (
    <>
        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%', flexDirection: 'column'}}>
            <Button onClick={() => throww('tamatar')}>Tamatar</Button>
            <Button onClick={() => throww('hearts')}>Hearts</Button>
            <Button onClick={() => throww('shit')}>Shit</Button>
            <Button onClick={() => throww('rainbow-shit')}>Rainbow Shit</Button>
            <Button onClick={() => throww('roses')}>Roses</Button>
            <Button onClick={() => throww('flash')}>Flash</Button>        
        </div>
    </>
  );
}
